import type { JSX } from 'react'
import type { IInputProps } from 'atoms/Input'
import type { IInputBlockProps } from '../InputBlock'

import { InputFonts } from 'atoms/Input'
import { LoginPasswordInput } from 'atoms/Input/Templates'
import { InputBlock } from '../InputBlock'
import { InputBlockRowGaps } from '../InputBlock.h'

export interface ILoginPasswordInputBlockProps extends Omit<
  IInputBlockProps,
  'children'
> {
  type?: IInputProps['type']
  value?: IInputProps['value']
  pattern?: IInputProps['pattern']
  required?: IInputProps['required']
  disabled?: IInputProps['disabled']
  defaultValue?: IInputProps['defaultValue']
  errorMessage?: IInputBlockProps['errorMessage']
  font?: IInputProps['font']
  placeholder?: IInputProps['placeholder']
  label?: IInputProps['label']
  onChange?: IInputProps['onChange']
  onBlur?: IInputProps['onBlur']
  autoComplete?: string
}

export const LoginPasswordInputBlock = ({
  type = 'text',
  value,
  pattern,
  required = true,
  disabled,
  defaultValue,
  errorMessage = '',
  rowGap = InputBlockRowGaps.SIZE_10,
  font = InputFonts.Body4,
  placeholder = '',
  label = '',
  width = 100,
  autoComplete,
  onChange,
  onBlur,
  ...rest
}: ILoginPasswordInputBlockProps): JSX.Element => (
  <InputBlock
    rowGap={rowGap}
    errorMessage={errorMessage}
    width={width}
    {...rest}
  >
    <LoginPasswordInput
      type={type}
      value={value}
      pattern={pattern}
      required={required}
      disabled={disabled}
      defaultValue={defaultValue}
      invalid={!!errorMessage}
      font={font}
      placeholder={placeholder}
      label={label}
      autoComplete={autoComplete}
      onChange={onChange}
      onBlur={onBlur}
    />
  </InputBlock>
)
